export default "__VITE_PUBLIC_ASSET__4d0da86e__"